export const filterParamsAdapter = <T extends object>(
  payload: T,
  droppedKeys?: string[]
) => {
  const droppedKeysSet = new Set(droppedKeys);
  const entries = Object.entries(payload)
    .filter(
      ([key, value]) =>
        value &&
        !(Array.isArray(value) && !value.length) &&
        !droppedKeysSet?.has(key)
    )
    .map(([key, value]) => {
      if (Array.isArray(value)) return [key, serializeArray(value)];
      return [key, value];
    });
  return Object.fromEntries(entries);
};

const serializeArray = <T>(arr: Array<T>) => `${arr}`;
